<template>
  <div class="about"
       id="abouttop">
    <Topper></Topper>
    <div class="nei_tit">
      <img src="../assets/about_tit.jpg"
           alt="" />
      <span>关于新奥</span>
    </div>

    <!-- 集团简介 -->
    <div class="jtjj_wrapper"
         id="jtjj"
         style="height:21.71rem;">
      <h2>集团简介</h2>
      <p>
        新奥集团1989年在河北廊坊创业起步，历经37年发展，已成为涵盖清洁能源、品质生活两大事业领域，拥有新奥能源（02688.HK）、新奥股份（600803.SH）、新智认知（603869.SH）、⻄藏旅游（600749.SH）4家上市公司，4万多名员⼯，在全国22个省服务3326万个家庭⽤户、32.8万家企业用户的企业集团，业务涉及城市燃⽓运营、天然⽓全球供应链、电力服务，以及智能家、智能游、健康服务等。2025年营业收入达1501亿元，在全国工商联发布的中国民营企业排行榜中排名第50位（按2024年营收数据统计）。
      </p>
      <p>
        面向智能时代，新奥集团以“用智能构建需供关系，打造现代能源体系
        、提⾼消费者⽣活品质，成为受⼈尊敬的创新型智慧企业”为使命愿景，依托庞大的客户资源和丰富的产业场景，聚焦家庭、企业客户的“品质化、低碳化、智能化”需求，建设打造基础能⼒平台恩牛网，构建家庭智能体、企业组织智能体，以“需智”和“软感算推”一体化方案落地“需供同智
        买卖俱精”新模式，积极推动智能化转型。
      </p>
      <p>
        秉持“执守良知、崇尚自驱、利他共生、成在数智”的价值观，新奥积极承担社会责任、注重自主技术创新和企业可持续发展。设立河北省新奥公益慈善基金会，投身公益慈善事业；与国内外60多所高校、科研院所合作建立联合研发平台，开展包括紧凑型聚变技术、产业智能技术在内的前瞻技术研究；将ESG理念融入公司治理，旗下上市公司新奥股份、新奥能源连续获评MSCI
        -
        ESG评级AAA，先后8次被民政部授予中国慈善事业的最高政府奖——“中华慈善奖”，被全国文明委评为全国文明单位。
      </p>
      <dl>
        <dt>40,000+</dt>
        <dd>现有员工数</dd>
      </dl>
      <dl>
        <dt>1,501 <i>亿</i></dt>
        <dd>2025年经营收入</dd>
      </dl>
      <dl style="border-right:0;">
        <dt>22 <i>省</i></dt>
        <dd>国内业务覆盖</dd>
      </dl>
    </div>

    <!-- 企业文化 -->
    <div class="qywh_wrapper"
         id="qywh">
      <h2>企业文化</h2>
      <dl>
        <dt>新奥之道</dt>
        <dd>源自客户 伙伴平等 生态共荣</dd>
      </dl>
      <dl>
        <dt>新奥使命愿景</dt>
        <dd>
          用智能构建需供关系 <br />打造现代能源体系 提高消费者生活品质<br />成为一家受人尊敬的创新型智慧企业
        </dd>
      </dl>
      <dl>
        <dt>新奥价值观</dt>
        <dd>执守良知 崇尚自驱 利他共生 成在数智</dd>
      </dl>
    </div>

    <!-- 社会责任 -->
    <div class="shzr_wrapper"
         id="shzz"
         style="height:30.23rem;">
      <h2>社会责任</h2>
      <div class="shzr_con">
        <img src="../assets/hjzr.jpg"
             alt="" />
        <h3>环境责任</h3>
        <p>推广清洁能源，实现节能减排，助力环境改善，为蓝天碧水增色。</p>
      </div>
      <div class="shzr_con">
        <img src="../assets/jyns.jpg"
             alt="" />
        <h3>就业纳税</h3>
        <p>
          员工总数超 4 万人，带动生态圈伙伴共同成长，持续扩大就业并积极纳税。
        </p>
      </div>
      <div class="shzr_con">
        <img src="../assets/cssy.jpg"
             alt="" />
        <h3>公益慈善</h3>
        <p>
          积极参与赈灾救灾、扶危济困、捐资助教。以产业扶贫、教育扶贫为主线开展精准扶贫工作。
        </p>
      </div>
    </div>

    <!-- 发展历程 -->
    <div class="fzlc_wrapper"
         id="fzlc">
      <h2>发展历程</h2>
      <!-- Swiper -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <span>1989</span>
            <p>在河北廊坊开始创业</p>
          </div>
          <div class="swiper-slide">
            <span>1993</span>
            <p>为廊坊开发区接通管道天然气</p>
          </div>
          <div class="swiper-slide">
            <span>1994</span>
            <p>从满足员工住房需求出发涉足房地产</p>
          </div>
          <div class="swiper-slide">
            <span>1999</span>
            <p>城市燃气业务开始走向全国</p>
          </div>
          <div class="swiper-slide">
            <span>2001</span>
            <p>新奥燃气在香港上市</p>
          </div>
          <div class="swiper-slide">
            <span>2004</span>
            <p>进军能源上游，自主研发高效煤制天然气技术</p>
          </div>
          <div class="swiper-slide">
            <span>2009</span>
            <p>发展清洁能源解决方案业务，助力节能减排</p>
          </div>
          <div class="swiper-slide">
            <span>2010</span>
            <p>提出并落地泛能网理念</p>
          </div>
          <div class="swiper-slide">
            <span>2011</span>
            <p>发布新绎品牌，布局文化、旅游产业</p>
          </div>
          <div class="swiper-slide">
            <span>2015</span>
            <p>上线“好气网”</p>
          </div>
          <div class="swiper-slide">
            <span>2016</span>
            <p>组建新智认知，提升数智化能力</p>
          </div>
          <div class="swiper-slide">
            <span>2018</span>
            <p>新奥舟山液化天然气接收站投运</p>
          </div>
          <div class="swiper-slide">
            <span>2019</span>
            <p>启动紧凑型核聚变实验；成立来康生命，布局智能健康产业</p>
          </div>
          <div class="swiper-slide">
            <span>2020</span>
            <p>新奥集团总部转型为新奥新智，建设运营产业数智平台</p>
          </div>
          <div class="swiper-slide">
            <span>2021</span>
            <p>发布恩牛平台，在天津投资建设物联感知产业园</p>
          </div>
          <div class="swiper-slide">
            <span>2022</span>
            <p>组建新智感知</p>
          </div>
          <div class="swiper-slide">
            <span>2023</span>
            <p>智能转型战略拼图布局完成</p>
          </div>
          <div class="swiper-slide">
            <span>2024</span>
            <p>提出“需供同智 买卖俱精”理念和商业模式</p>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination"></div>
      </div>
      <!-- Swiper -->
    </div>

    <!-- 领导团队 -->
    <div class="ldtd_wrapper "
         id="ldtd"
         style="height:48.23rem;">
      <h2>领导团队</h2>
      <ul>
        <li>
          <img src="../assets/leaders/wangyusuo.jpg" />
          <div class="ldtd_text">
            <span>王玉锁</span>
            <p>新奥集团董事局主席</p>
            <p>毕业于天津财经大学管理系企业管理专业，获博士学位。</p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/yujianchao.jpg" />
          <div class="ldtd_text">
            <span>于建潮 先生</span>
            <p>新奥集团董事长</p>
            <p>
              毕业于中欧国际工商学院工商管理专业，获MBA学位，获清华大学EMBA学位。
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/zhangjin.jpg" />
          <div class="ldtd_text">
            <span>张瑾 女士</span>
            <p>新奥集团副董事长</p>
            <p>中国人民大学，工商管理学院企业管理专业，获管理学硕士学位。</p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/wangzizheng.jpg" />
          <div class="ldtd_text">
            <span>王子峥 先生</span>
            <p>新奥集团董事</p>
            <p>毕业于同济大学城市规划专业。</p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/wangdongzhi.jpg" />
          <div class="ldtd_text">
            <span>王冬至 先生</span>
            <p>新奥集团董事</p>
            <p>
              毕业于天津大学工商管理专业，获工商管理学硕士学位，取得中国执业会计师资格。
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/yangyu.jpg" />
          <div class="ldtd_text">
            <span>杨宇 先生</span>
            <p>新奥集团董事</p>
            <p style="line-height: 130%;">
              毕业于石油管道职业技术学院无线电通讯专业，获人民大学货币银行学硕士学位，获新加坡南洋理工大学EMBA学位。
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/zhangyuying.jpg" />
          <div class="ldtd_text">
            <span>张宇迎 先生</span>
            <p>新奥集团董事</p>
            <p style="line-height: 130%;">
              毕业于中国人民大学工商管理专业，获北京大学EMBA学位。
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/jinyongsheng.jpg" />
          <div class="ldtd_text">
            <span>金永生 先生</span>
            <p>新奥集团董事</p>
            <p>
              毕业于天津财经学院财政专业，获北京大学EMBA学位，取得全国律师从业资格。
            </p>
          </div>
        </li>
        <li>
          <img src="../assets/leaders/jiangchenghong.jpg" />
          <div class="ldtd_text">
            <span>蒋承宏 先生</span>
            <p>新奥集团董事</p>
            <p>
              毕业于武汉大学金融保险专业，获加拿大萨斯喀彻温大学MBA学位，获厦门大学EMBA学位，取得全国律师从业资格。
            </p>
          </div>
        </li>
        <!-- <li>
          <img src="../assets/leaders/zhaojinfeng.jpg">
          <div class="ldtd_text">
            <span>赵金峰 先生</span>
            <p>新奥集团董事</p>
            <p>毕业于中欧国际工商学院工商管理专业，获EMBA学位。</p>
          </div>
        </li> -->
        <!--li>
          <img src="../assets/leaders/guojijun.jpg">
          <div class="ldtd_text">
            <span>郭继军 先生</span>
            <p>新奥集团董事 新奥新智CEO兼总裁</p>
            <p>毕业于上海交通大学计算机网络专业，研究生学历，获硕士学位。</p>
          </div>
        </li-->
        <!-- <li>
          <img src="../assets/leaders/hanjishen.jpg">
          <div class="ldtd_text">
            <span>韩继深 先生</span>
            <p>新奥集团董事 新奥股份联席CEO</p>
            <p>毕业于新加坡南洋理工大学，获EMBA学位。</p>
          </div>
        </li> -->
      </ul>
    </div>

    <!-- 股票信息 -->
    <div class="gpxx_wrapper"
         id="gpxx"
         style="height:29.31rem;">
      <h2>股票信息</h2>
      <ul>
        <li v-if="elements0 && elements0.length > 0">
          <img src="../assets/02688.jpg"
               alt="" />
          <span class="gp_mingzi">新奥能源</span>
          <span class="gp_daima">02688.HK</span>
          <span :class="
              'gp_jiage ' +
                (elements0[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements0[3]).toFixed(2) }}<i>港元</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements0[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements0[32]).toFixed(2) }}%</span>
          <span class="gp_gaozui">最高<i class="red">{{
              parseFloat(elements0[33]).toFixed(2)
            }}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{
              parseFloat(elements0[34]).toFixed(2)
            }}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{ (parseFloat(elements0[37]) / 10000).toFixed(2) }}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{ (parseFloat(elements0[36]) / 10000).toFixed(2) }}万股</i></span>
        </li>
        <li v-if="elements1 && elements1.length > 0">
          <img src="../assets/600803.jpg"
               alt="" />
          <span class="gp_mingzi">新奥股份</span>
          <span class="gp_daima">600803.SH</span>
          <span :class="
              'gp_jiage ' +
                (elements1[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements1[3]).toFixed(2) }}<i>元</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements1[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements1[32]).toFixed(2) }}%</span>
          <span class="gp_gaozui">最高<i class="red">{{
              parseFloat(elements1[33]).toFixed(2)
            }}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{
              parseFloat(elements1[34]).toFixed(2)
            }}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{ parseFloat(elements1[37]).toFixed(2) }}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{ (parseFloat(elements1[36]) / 10000).toFixed(2) }}万股</i></span>
        </li>
        <li v-if="elements2 && elements2.length > 0">
          <img src="../assets/603869.jpg"
               alt="" />
          <span class="gp_mingzi">ST智知</span>
          <span class="gp_daima">603869.SH</span>
          <span :class="
              'gp_jiage ' +
                (elements2[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements2[3]).toFixed(2) }}<i>元</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements2[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements2[32]).toFixed(2) }}%</span>
          <span class="gp_gaozui">最高<i class="red">{{
              parseFloat(elements2[33]).toFixed(2)
            }}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{
              parseFloat(elements2[34]).toFixed(2)
            }}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{ parseFloat(elements2[37]).toFixed(2) }}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{ (parseFloat(elements2[36]) / 10000).toFixed(2) }}万股</i></span>
        </li>
        <li v-if="elements3 && elements3.length > 0">
          <img src="../assets/600749.jpg"
               alt="" />
          <span class="gp_mingzi">西藏旅游</span>
          <span class="gp_daima">600749.SH</span>
          <span :class="
              'gp_jiage ' +
                (elements3[32].toString().includes('-') ? 'green' : 'red')
            ">{{ parseFloat(elements3[3]).toFixed(2) }}<i>元</i></span>
          <span :class="
              'gp_zhangfu ' +
                (elements3[32].toString().includes('-') ? 'greenbg' : 'redbg')
            ">{{ parseFloat(elements3[32]).toFixed(2) }}%</span>
          <span class="gp_gaozui">最高<i class="red">{{
              parseFloat(elements3[33]).toFixed(2)
            }}</i></span>
          <span class="gp_zuidi">最低<i class="green">{{
              parseFloat(elements3[34]).toFixed(2)
            }}</i></span>
          <span class="gp_chengjiaoe">成交额<i>{{ parseFloat(elements3[37]).toFixed(2) }}万</i></span>
          <span class="gp_chengjiaoliang">成交量<i>{{ (parseFloat(elements3[36]) / 10000).toFixed(2) }}万股</i></span>
        </li>
      </ul>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import Swiper from "swiper";
import Topper from "./Topper";
import Footer from "./Footer.vue";
export default {
  components: {
    Topper,
    Footer
  },
  name: "about",
  data () {
    return {
      elements0: [],
      elements1: [],
      elements2: [],
      elements3: []
    };
  },
  methods: {
    loadUrl () {
      //   let url = 'https://qt.gtimg.cn/q=hk02688,sh600803,sh603869,sh600749'
      let url = "/qtapi/q=hk02688,sh600803,sh603869,sh600749";
      axios
        .get(url)
        .then(response => {
          let strArray = response.data.split(";");
          this.elements0 = strArray[0].split("~");
          this.elements1 = strArray[1].split("~");
          this.elements2 = strArray[2].split("~");
          this.elements3 = strArray[3].split("~");

          //跳锚点
          let maodian = this.$route.params.maodian;
          console.log(maodian);
          if (maodian) {
            this.$nextTick(() => {
              const targetElement = document.querySelector(maodian);
              window.scrollTo({
                top: targetElement.offsetTop - 45,
                behavior: "smooth"
              });
            });
          } else {
            window.scrollTo(0, 0);
          }
        })

        .catch(error => {
          console.error("There was an error fetching the content:", error);
        });
    }
  },
  mounted () {
    new Swiper(".swiper-container", {
      loop: false,
      // 如果需要分页器
      //   pagination: ".swiper-pagination",
      grabCursor: true,
      centeredSlides: false,
      slidesPerView: "auto",
      //   autoplay: 3000,
      autoplayDisableOnInteraction: false //用户操作后是否自动播放
      //   parallax: true,//允许延迟
    });

    this.loadUrl();
  }
};
</script>

<style scoped>
.about {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
.jtjj_wrapper {
  padding: 0 40px;
  width: 670px;
  height: auto;
  overflow: hidden;
  float: left;
}
.about h2 {
  width: 100%;
  height: auto;
  font-size: 36px;
  color: #1d2129;
  text-align: left;
  padding-top: 65px;
  padding-bottom: 30px;
}
.about p {
  width: 100%;
  height: auto;
  font-size: 28px;
  color: #1d2129;
  text-align: left;
  margin-bottom: 50px;
  line-height: 150%;
}
.jtjj_wrapper dl {
  width: 200px;
  height: auto;
  float: left;
  padding: 0 10px;
  border-right: 1px solid #ddd;
}
.jtjj_wrapper dl dt {
  color: #003f84;
  font-size: 40px;
  font-family: dingding;
  padding-bottom: 10px;
}
.jtjj_wrapper dl dd {
  color: #1d2129;
  font-size: 20px;
}
.jtjj_wrapper dl dt i {
  font-style: normal;
  font-size: 25px;
  font-weight: 600;
}

.qywh_wrapper {
  width: 670px;
  height: 420px;
  background: url(../assets/qywh_bg.jpg) center no-repeat;
  background-size: 100% 100%;
  float: left;
  margin-top: 60px;
  padding: 60px 40px;
}
.qywh_wrapper h2 {
  padding-top: 0;
  padding-bottom: 50px;
  color: #fff;
}
.qywh_wrapper dl {
  width: 650px;
  float: left;
  margin-bottom: 30px;
}
.qywh_wrapper dl dt {
  width: 190px;
  float: left;
  font-size: 28px;
  color: #fff;
  font-weight: 600;
  text-align: left;
}
.qywh_wrapper dl dd {
  width: 460px;
  float: left;
  font-size: 26px;
  color: #fff;
  text-align: left;
  line-height: 180%;
}

/* 社会职责 */
.shzr_wrapper {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
}
.shzr_wrapper h2 {
  width: 710px;
  padding-left: 40px;
}
.shzr_wrapper img {
  width: 750px;
}
.shzr_wrapper h3 {
  width: 710px;
  padding: 35px 0 10px 40px;
  font-size: 36px;
  text-align: left;
}
.shzr_wrapper .shzr_con {
  border-bottom: 24px solid #f1f2f6;
}
.shzr_wrapper .shzr_con p {
  font-size: 28px;
  color: #323233;
  width: 670px;
  display: block;
  padding: 5px 40px;
}

/* 发展历程 */
.fzlc_wrapper {
  width: 750px;
  height: 650px;
  background: url(../assets/fzlc_bg.jpg) center no-repeat;
  background-size: 100% 100%;
  float: left;
  border-top: 35px solid #f1f2f6;
}
.fzlc_wrapper h2 {
  width: 710px;
  padding-left: 40px;
}
.swiper-container {
  width: 710px;
  height: 300px;
  margin-top: 60px;
  padding-left: 40px;
}

.swiper-wrapper {
  width: 710px;
  height: 300px;
}
.swiper-container .swiper-slide {
  width: 320px;
  height: 300px;
  position: relative;
  float: left;
  background: url(../assets/fzlc_libg.png) 0 210px no-repeat;
}

.swiper-container .swiper-slide span {
  height: auto;
  display: block;
  text-align: left;
  overflow: hidden;
  font-size: 64px;
  padding-bottom: 15px;
  color: #003f84;
  font-weight: 600;
  font-family: dingding;
}
.swiper-container .swiper-slide p {
  width: 260px;
  height: auto;
  display: block;
  text-align: left;
  overflow: hidden;
  font-size: 28px;
  line-height: 32px;
  color: #1d2129;
}

/* 领导团队 */
.ldtd_wrapper {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
  background: #f1f2f6;
}
.ldtd_wrapper h2 {
  padding-left: 40px;
  width: 710px;
  padding-top: 60px;
  padding-bottom: 50px;
}
.ldtd_wrapper li {
  width: 750px;
  height: auto;
  float: left;
  background: #fff;
  margin-bottom: 25px;
}
.ldtd_wrapper li img {
  width: 330px;
  height: 330px;
  float: left;
}
.ldtd_wrapper li .ldtd_text {
  width: 340px;
  height: auto;
  float: left;
  padding: 40px;
}
.ldtd_wrapper li .ldtd_text span {
  font-size: 32px;
  text-align: left;
  color: #1d2129;
  display: block;
  font-weight: 600;
}
.ldtd_wrapper li .ldtd_text p {
  display: block;
  padding-bottom: 24px;
  font-size: 28px;
  color: #323233;
  margin: 0;
  line-height: 140%;
}

/* 股票信息 */
.gpxx_wrapper {
  width: 750px;
  height: auto;
  overflow: hidden;
  float: left;
  background: #f1f2f6;
}
.gpxx_wrapper h2 {
  padding-left: 40px;
  width: 710px;
  padding-top: 60px;
  padding-bottom: 50px;
}
.gpxx_wrapper li {
  width: 750px;
  height: 485px;
  float: left;
  background: #fff;
  margin-bottom: 25px;
  position: relative;
}
.gpxx_wrapper li img {
  width: 750px;
  height: 330px;
  float: left;
  position: absolute;
  left: 0;
  top: 0;
}
.gpxx_wrapper li .gp_mingzi {
  width: 750px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  text-align: center;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  left: 0;
  top: 125px;
  display: block;
}
.gpxx_wrapper li .gp_daima {
  display: block;
  width: 750px;
  height: 50px;
  line-height: 50px;
  position: absolute;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 600;
  left: 0;
  top: 180px;
}
.gpxx_wrapper li .gp_jiage {
  display: block;
  position: absolute;
  width: 210px;
  height: 40px;
  font-weight: 900;
  font-size: 40px;
  left: 40px;
  top: 360px;
  text-align: left;
}
.gpxx_wrapper li .gp_jiage i {
  font-size: 24px;
  font-style: normal;
}
.gpxx_wrapper li .green {
  color: #308f40;
}
.gpxx_wrapper li .red {
  color: #cc4646;
}
.gpxx_wrapper li .gp_zhangfu {
  display: block;
  position: absolute;
  width: 170px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  left: 40px;
  top: 415px;
  font-size: 24px;
}
.gpxx_wrapper li .greenbg {
  background: #308f40;
  color: #fff;
}
.gpxx_wrapper li .redbg {
  background: #cc4646;
  color: #fff;
}
.gpxx_wrapper li .gp_gaozui {
  display: block;
  position: absolute;
  width: 190px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 270px;
  top: 370px;
  font-size: 28px;
  color: #323233;
}
.gpxx_wrapper li .gp_zuidi {
  display: block;
  position: absolute;
  width: 190px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 270px;
  top: 415px;
  font-size: 28px;
  color: #323233;
}
.gpxx_wrapper li .gp_gaozui i,
.gpxx_wrapper li .gp_zuidi i,
.gpxx_wrapper li .gp_chengjiaoe i,
.gpxx_wrapper li .gp_chengjiaoliang i {
  font-style: normal;
  padding-left: 15px;
}
.gpxx_wrapper li .gp_chengjiaoe {
  display: block;
  position: absolute;
  width: 250px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 465px;
  top: 370px;
  font-size: 28px;
  color: #323233;
}
.gpxx_wrapper li .gp_chengjiaoliang {
  display: block;
  position: absolute;
  width: 250px;
  height: 38px;
  line-height: 38px;
  text-align: left;
  left: 465px;
  top: 415px;
  font-size: 28px;
  color: #323233;
}
</style>
